import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-load-handover',
  templateUrl: './load-handover.component.html',
  styleUrls: ['./load-handover.component.scss']
})
export class LoadHandoverComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
